import { render, staticRenderFns } from "./gl.vue?vue&type=template&id=08e944bd&scoped=true"
import script from "./gl.vue?vue&type=script&lang=js"
export * from "./gl.vue?vue&type=script&lang=js"
import style0 from "./gl.vue?vue&type=style&index=0&id=08e944bd&prod&scoped=true&lang=css"
import style1 from "./gl.vue?vue&type=style&index=1&id=08e944bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e944bd",
  null
  
)

export default component.exports